// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    position: 'relative',
    width: '100%',
    height: 800,
    overflow: 'hidden',
    marginTop: 70,
    [theme.breakpoints.down(1600)]: {
      height: 710,
    },
    [theme.breakpoints.down(1368)]: {
      height: 600,
    },
    [theme.breakpoints.down(1025)]: {
      height: 500,
    },
    [theme.breakpoints.down(1000)]: {
      height: '100%',
    },
  },
  imageContainer: {
    position: 'absolute',
    zIndex: -1,
    right: -250,
    [theme.breakpoints.down(1800)]: {
      right: -350,
    },
    [theme.breakpoints.down(1600)]: {
      right: -500,
    },
    [theme.breakpoints.down(1368)]: {
      right: -550
    },
    [theme.breakpoints.down(1025)]: {
      right: -750,
    },
  },
  backgroundImage: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.down(1800)]: {
      width: '94%',
    },
    [theme.breakpoints.down(1600)]: {
      width: '80%',
    },
    [theme.breakpoints.down(1368)]: {
      width: '76%',
    },
    [theme.breakpoints.down(1025)]: {
      width: '60%',
    },
  },
  mainInnerContainer: {
    width: 900,
    padding: 26,
    marginTop: 70,
    backgroundColor: 'transparent',
    [theme.breakpoints.down(1800)]: {
      marginTop: 50,
      width: 850,
    },
    [theme.breakpoints.down(1600)]: {
      marginTop: 20,
      width: 720,
    },
    [theme.breakpoints.down(1500)]: {
      marginTop: 20,
      width: 670,
    },
    [theme.breakpoints.down(1368)]: {
      marginTop: 20,
      width: 640,
    },
    [theme.breakpoints.down(1025)]: {
      marginTop: 0,
      width: 540,
    },
    [theme.breakpoints.down(1000)]: {
      width: '80%',
    },
    [theme.breakpoints.down(768)]: {
      width: '100%',
    },
    [theme.breakpoints.down(500)]: {
      padding: 5,
    },
  },
  inputContainer: {
    marginTop: 40,
    marginBottom: 60,
    [theme.breakpoints.down(1800)]: {
      marginTop: 30,
      marginBottom: 50,
    },
    [theme.breakpoints.down(1368)]: {
      marginTop: 20,
      marginBottom: 30,
    },
    [theme.breakpoints.down(1025)]: {
      marginTop: 20,
      marginBottom: 30,
    },
  },
  text: {
    fontSize: GlobalStyles.fonts.FONT_SIZE_EXTRA_MAX,
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_BOLD,
    [theme.breakpoints.down(1800)]: {
      fontSize: 42,
    },
    [theme.breakpoints.down(1600)]: {
      fontSize: 32,
    },
    [theme.breakpoints.down(1368)]: {
      fontSize: 28,
    },
    [theme.breakpoints.down(500)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE
    },
    [theme.breakpoints.down(330)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE
    },
  }
});

export default styles;
